export default function AppDownload() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-100/60 via-primary-50/40 to-accent-100/50 rounded-2xl p-8 md:p-12 border border-primary-200/50">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                下载韩漫之家APP
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                一键安装韩漫APK，即刻享受海量韩漫离线免费阅读。支持安卓与iOS设备，
                下载速度快、安装简单，随时随地打开就能看最新韩漫。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 font-semibold rounded-full text-sm hover:bg-foreground-800 transition-colors"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-900 font-semibold rounded-full text-sm border border-foreground-300 hover:bg-foreground-50 transition-colors"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
              </div>
              <p className="text-xs text-foreground-400 mt-4">
                版本 v3.8.2 · 大小 48MB · 已通过安全检测
              </p>
            </div>

            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20minimalist%20app%20download%20promo%20card%20with%20Korean%20webtoon%20style%20illustration%2C%20smartphone%20showing%20colorful%20comic%20panels%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20modern%20app%20marketing%20design%2C%20soft%20gradient%20background&width=600&height=600&seq=app-qr-2026&orientation=squarish"
                  alt="韩漫之家APP下载"
                  title="韩漫之家 - 韩漫APK下载"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}